export default __webpack_public_path__ + "static/media/pop_up_arrow.7e245db6.svg";